import { useMemo } from 'react'
import { Helmet } from 'react-helmet-async'
import { useSelector } from 'react-redux'
import { matchPath, useLocation } from 'react-router-dom'
import { isMobileOnly } from 'react-device-detect'

import PropTypes from 'prop-types'

import { getIsSideNavbarEnabled, getMainBackgroundColor, getTenantName } from '@tabeeb/modules/appConfigState/selectors'

import LegacyNavbar from '@tabeeb/modules/legacyNavbar'
import SideNavbar from '@tabeeb/modules/navbar'

import routes from '@tabeeb/routes'

const environmentBannerText = process.env.ENVIRONMENT_BANNER_TEXT

const hideNavbarOn = [
  routes.createProfile,
  routes.appPrivacyPolicy,
  routes.appTermsOfUse,
  routes.joinSessionViaInvite,
  routes.signInSilentCallback,
  routes.signInRedirectCallback,
  routes.signOutRedirectCallback,
  routes.switchTenant,
  routes.legacyRegister,
  routes.legacyConfirmEmail,
  routes.readonlyContent,
]

const Root = ({ children }) => {
  const location = useLocation()
  const tenantName = useSelector(getTenantName)

  const hideNavbar = useMemo(
    () => hideNavbarOn.some((path) => matchPath(location.pathname, { path })) || isMobileOnly,
    [location.pathname]
  )

  const isSideNavbarEnabled = useSelector(getIsSideNavbarEnabled)
  const backgroundColor = useSelector(getMainBackgroundColor)

  const NavbarComponent = isSideNavbarEnabled ? SideNavbar : LegacyNavbar

  return (
    <NavbarComponent hidden={hideNavbar}>
      <Helmet>
        <title>{tenantName}</title>
      </Helmet>

      {environmentBannerText && (
        <div
          style={{
            backgroundColor: '#e4a11b',
            display: 'flex',
            justifyContent: 'center',
            fontSize: '20px',
            textAlign: 'center',
          }}
        >
          {environmentBannerText}
        </div>
      )}
      <div
        style={{
          height: '100%',
          overflowY: 'auto',
          overflowX: 'hidden',
          backgroundColor: isSideNavbarEnabled ? '#f9f9f9' : backgroundColor,
        }}
      >
        {children}
      </div>
    </NavbarComponent>
  )
}

Root.propTypes = {
  children: PropTypes.element,
}

export default Root
